import { render } from "./WhiteBook.vue?vue&type=template&id=c9ab08b2&scoped=true"
import script from "./WhiteBook.vue?vue&type=script&lang=js"
export * from "./WhiteBook.vue?vue&type=script&lang=js"

import "./WhiteBook.vue?vue&type=style&index=0&id=c9ab08b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9ab08b2"]])

export default __exports__